import {Home} from "../../../common/interface/interface";

export const housesData : Array<Home> = [
  {
    imageUrl: "./images/home1.jpg",
    houseName: "Cozy Cottage",
    ratings: 4.5,
    price: 200000,
    location: "Chicago, IL",
    bhk: 2,
    ownedBy: "johndoe",
  },
  {
    imageUrl: "./images/home2.jpg",
    houseName: "Elegant Estate",
    ratings: 4.8,
    price: 800000,
    location: "New York, NY",
    bhk: 4,
    ownedBy: "janedoe",
  },
  {
    imageUrl: "./images/home3.jpg",
    houseName: "Rustic Retreat",
    ratings: 4.3,
    price: 300000,
    location: "Asheville, NC",
    bhk: 3,
    ownedBy: "mikejones",
  },
  {
    imageUrl: "./images/home4.jpg",
    houseName: "Ocean View Villa",
    ratings: 4.7,
    price: 1200000,
    location: "Honolulu, HI",
    bhk: 5,
    ownedBy: "lisasimpson",
  },
  {
    imageUrl: "./images/home5.jpg",
    houseName: "Charming Cottage",
    ratings: 4.2,
    price: 150000,
    location: "Nashville, TN",
    bhk: 2,
    ownedBy: "jamesbond",
  },
  {
    imageUrl: "./images/home6.jpg",
    houseName: "Modern Mansion",
    ratings: 4.9,
    price: 2500000,
    location: "Los Angeles, CA",
    bhk: 6,
    ownedBy: "sarahsmith",
  },
  {
    imageUrl: "./images/home7.jpg",
    houseName: "Lakeside Lodge",
    ratings: 4.6,
    price: 500000,
    location: "Minneapolis, MN",
    bhk: 3,
    ownedBy: "adamjones",
  },
  {
    imageUrl: "./images/home8.jpg",
    houseName: "Countryside Cottage",
    ratings: 4.2,
    price: 180000,
    location: "Charleston, SC",
    bhk: 2,
    ownedBy: "katiejackson",
  },
  {
    imageUrl: "./images/home9.jpg",
    houseName: "Historic Home",
    ratings: 4.4,
    price: 550000,
    location: "Savannah, GA",
    bhk: 4,
    ownedBy: "michaeljackson",
  },
  {
    imageUrl: "./images/home10.jpg",
    houseName: "Seaside Villa",
    ratings: 4.7,
    price: 900000,
    location: "Miami, FL",
    bhk: 4,
    ownedBy: "robertdowney",
  },
  {
    imageUrl: "./images/home11.jpg",
    houseName: "Beautiful Seaside House",
    ratings: 4,
    price: 800000,
    location: "Miami, FL",
    bhk: 4,
    ownedBy: "john123",
  },
  {
    imageUrl: "./images/home12.jpg",
    houseName: "Cozy Cottage in the Woods",
    ratings: 3,
    price: 250000,
    location: "Asheville, NC",
    bhk: 2,
    ownedBy: "sarah81",
  },
  {
    imageUrl: "./images/home13.jpg",
    houseName: "Luxury High-Rise Condo",
    ratings: 5,
    price: 1200000,
    location: "New York, NY",
    bhk: 3,
    ownedBy: "johndoe",
  },
  {
    imageUrl: "./images/home14.jpg",
    houseName: "Charming Bungalow in the City",
    ratings: 4,
    price: 400000,
    location: "Seattle, WA",
    bhk: 2,
    ownedBy: "amy88",
  },
  {
    imageUrl: "./images/home15.jpg",
    houseName: "Mansion with Spectacular Views",
    ratings: 5,
    price: 5000000,
    location: "Los Angeles, CA",
    bhk: 6,
    ownedBy: "smith007",
  },
  {
    imageUrl: "./images/home16.jpg",
    houseName: "Elegant Townhouse with Garden",
    ratings: 4,
    price: 900000,
    location: "Chicago, IL",
    bhk: 3,
    ownedBy: "david23",
  },
  {
    imageUrl: "./images/home17.jpg",
    houseName: "Rustic Cabin by the Lake",
    ratings: 3,
    price: 150000,
    location: "Boulder, CO",
    bhk: 1,
    ownedBy: "hannah82",
  },
  {
    imageUrl: "./images/home18.jpg",
    houseName: "Contemporary Loft in the City",
    ratings: 4,
    price: 650000,
    location: "Portland, OR",
    bhk: 2,
    ownedBy: "mike56",
  },
  {
    imageUrl: "./images/home19.jpg",
    houseName: "Traditional Home with Modern Touches",
    ratings: 4,
    price: 550000,
    location: "Salt Lake City, UT",
    bhk: 3,
    ownedBy: "kate99",
  },
  {
    imageUrl: "./images/home20.jpg",
    houseName: "Mediterranean Villa with Pool",
    ratings: 5,
    price: 3500000,
    location: "San Diego, CA",
    bhk: 5,
    ownedBy: "lucas77",
  },
  {
    imageUrl: "./images/home21.jpg",
    houseName: "The Sunflower House",
    ratings: 4.5,
    price: 280000,
    location: "Los Angeles",
    bhk: 3,
    ownedBy: "john_doe",
  },
  {
    imageUrl: "./images/home22.jpg",
    houseName: "The Skyline Tower",
    ratings: 4.8,
    price: 400000,
    location: "New York City",
    bhk: 2,
    ownedBy: "jane_smith",
  },
  {
    imageUrl: "./images/home23.jpg",
    houseName: "The Lavender Estate",
    ratings: 4.2,
    price: 230000,
    location: "San Francisco",
    bhk: 1,
    ownedBy: "jimmy_wong",
  },
  {
    imageUrl: "./images/home24.jpg",
    houseName: "The Oak Grove Cottage",
    ratings: 4.6,
    price: 350000,
    location: "Seattle",
    bhk: 2,
    ownedBy: "alice_kim",
  },
  {
    imageUrl: "./images/home25.jpg",
    houseName: "The Oceanfront Villa",
    ratings: 4.9,
    price: 900000,
    location: "Miami",
    bhk: 4,
    ownedBy: "william_smith",
  },
  {
    imageUrl: "./images/home26.jpg",
    houseName: "The Rustic Lodge",
    ratings: 4.1,
    price: 180000,
    location: "Denver",
    bhk: 1,
    ownedBy: "samantha_baker",
  },
  {
    imageUrl: "./images/home27.jpg",
    houseName: "The Mountain Retreat",
    ratings: 4.7,
    price: 540000,
    location: "Aspen",
    bhk: 3,
    ownedBy: "jason_kim",
  },
  {
    imageUrl: "./images/home28.jpg",
    houseName: "The Lakeside Mansion",
    ratings: 4.9,
    price: 1250000,
    location: "Lake Tahoe",
    bhk: 5,
    ownedBy: "sara_johnson",
  },
  {
    imageUrl: "./images/home29.jpg",
    houseName: "The Garden Estate",
    ratings: 4.4,
    price: 310000,
    location: "Portland",
    bhk: 2,
    ownedBy: "kelly_nguyen",
  },
  {
    imageUrl: "./images/home30.jpg",
    houseName: "The Beachfront Bungalow",
    ratings: 4.6,
    price: 420000,
    location: "Honolulu",
    bhk: 2,
    ownedBy: "nathan_kim",
  },
  {
    imageUrl: "./images/home31.jpg",
    houseName: "Villa Royale",
    ratings: 5,
    price: 20000000,
    location: "Malibu, California",
    bhk: 5,
    ownedBy: "johnsmith",
  },
  {
    imageUrl: "./images/home32.jpg",
    houseName: "Hollywood Mansion",
    ratings: 4,
    price: 15000000,
    location: "Los Angeles, California",
    bhk: 4,
    ownedBy: "jenniferlopez",
  },
  {
    imageUrl: "./images/home33.jpg",
    houseName: "Modern Condo",
    ratings: 4,
    price: 5000000,
    location: "Miami, Florida",
    bhk: 2,
    ownedBy: "williamturner",
  },
  {
    imageUrl: "./images/home34.jpg",
    houseName: "Beach House",
    ratings: 3,
    price: 8000000,
    location: "Santa Barbara, California",
    bhk: 3,
    ownedBy: "oliverjones",
  },
  {
    imageUrl: "./images/home35.jpg",
    houseName: "Country Estate",
    ratings: 5,
    price: 12000000,
    location: "Franklin, Tennessee",
    bhk: 4,
    ownedBy: "emilydavis",
  },
  {
    imageUrl: "./images/home36.jpg",
    houseName: "Luxury Apartment",
    ratings: 4,
    price: 6000000,
    location: "New York City, New York",
    bhk: 3,
    ownedBy: "charlesbrown",
  },
  {
    imageUrl: "./images/home37.jpg",
    houseName: "Spanish Villa",
    ratings: 5,
    price: 18000000,
    location: "Santa Barbara, California",
    bhk: 6,
    ownedBy: "isabellawoods",
  },
  {
    imageUrl: "./images/home38.jpg",
    houseName: "Mountain Lodge",
    ratings: 4,
    price: 10000000,
    location: "Jackson Hole, Wyoming",
    bhk: 5,
    ownedBy: "ethancampbell",
  },
  {
    imageUrl: "./images/home39.jpg",
    houseName: "Cape Cod Home",
    ratings: 3,
    price: 7000000,
    location: "Nantucket, Massachusetts",
    bhk: 4,
    ownedBy: "madisonjohnson",
  },
  {
    imageUrl: "./images/home40.jpg",
    houseName: "Penthouse Suite",
    ratings: 5,
    price: 25000000,
    location: "Dubai, United Arab Emirates",
    bhk: 7,
    ownedBy: "nicholaswhite",
  },
  {
    imageUrl: "./images/home41.jpg",
    houseName: "Luxury Villa in the Heart of the City",
    ratings: 4.5,
    price: 24000000,
    location: "Koramangala, Bangalore",
    bhk: 5,
    ownedBy: "Samir",
  },
  {
    imageUrl: "./images/home42.jpg",
    houseName: "Spacious 3 BHK Apartment with Stunning Views",
    ratings: 4,
    price: 9500000,
    location: "Gurgaon Sector 56, Gurgaon",
    bhk: 3,
    ownedBy: "Rahul",
  },
  {
    imageUrl: "./images/home43.jpg",
    houseName: "Beautifully Furnished 2 BHK Flat",
    ratings: 3.5,
    price: 6200000,
    location: "Noida Sector 75, Noida",
    bhk: 2,
    ownedBy: "Arun",
  },
  {
    imageUrl: "./images/home44.jpg",
    houseName: "Luxury Penthouse with Private Terrace",
    ratings: 4.5,
    price: 60000000,
    location: "Malabar Hill, Mumbai",
    bhk: 4,
    ownedBy: "Neeraj",
  },
  {
    imageUrl: "./images/home45.jpg",
    houseName: "Beautiful Farmhouse with Pool and Garden",
    ratings: 5,
    price: 120000000,
    location: "Sohna Road, Gurgaon",
    bhk: 5,
    ownedBy: "Kapil",
  },
  {
    imageUrl: "./images/home46.jpg",
    houseName: "La de Fatte House",
    ratings: 2,
    price: 17000000,
    location: "Sohna Road, Dehli",
    bhk: 3,
    ownedBy: "Kushal",
  },
  {
    imageUrl: "./images/home47.jpg",
    houseName: "Jannt House",
    ratings: 2,
    price: 17000000,
    location: "Amar Taj, Dehli",
    bhk: 3,
    ownedBy: "AbhiShek",
  },
  {
    imageUrl: "./images/home48.jpg",
    houseName: "Veera House",
    ratings: 2,
    price: 17000000,
    location: "Chandni Chowk, Dehli",
    bhk: 3,
    ownedBy: "Amar",
  },
];
